module.exports = __webpack_public_path__ + "img/8.59db6df3.png";